import axios from 'axios'
import { authHeader } from '@/util/helpers'
import getEnv from '@/util/env'

const host = getEnv('VUE_APP_API_HOST')

const state = {
  web: [],
  csr: [],
  imq: [],
  win: [],
  itm: []
}

const mutations = {
  'GET_WEB' (state) {
    axios
      .get(
        `${host}/v2/servers/web?include=contract;last_modified_by_user&filters=deleted:n`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.web = response.data
      })
  },
  'GET_CSR' (state) {
    axios
      .get(
        `${host}/v2/servers/csr?include=contract;last_modified_by_user&filters=deleted:n`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.csr = response.data
      })
  },
  'GET_IMQ' (state) {
    axios
      .get(
        `${host}/v2/servers/imq?include=contract;last_modified_by_user&filters=deleted:n`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.imq = response.data
      })
  },
  'GET_WIN' (state) {
    axios
      .get(
        `${host}/v2/servers/win?include=contract;last_modified_by_user&filters=deleted:n`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.win = response.data
      })
  },
  'GET_ITM' (state) {
    axios
      .get(
        `${host}/v2/servers/itm?include=contract;last_modified_by_user&filters=deleted:n`,
        {
          headers: authHeader(),
        },
      )
      .then(response => {
        state.itm = response.data
      })
  }
}

const getters = {
  web: state => {
    return state.web
  },
  csr: state => {
    return state.csr
  },
  imq: state => {
    return state.imq
  },
  win: state => {
    return state.win
  },
  itm: state => {
    return state.itm
  }
}

const actions = {
  load ({ commit }) {
    commit('GET_WEB')
    commit('GET_CSR')
    commit('GET_IMQ')
    commit('GET_WIN')
    commit('GET_ITM')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
